<p>downloadpaymentconfirmation works!</p>
